import React from 'react';

const PlayVoice = () => {
    return (
        <svg width={21} height={21} viewBox="0 0 21 21">
            <g transform="translate(-92 -688)">
                <circle
                    cx={10.5}
                    cy={10.5}
                    r={10.5}
                    transform="translate(92 688)"
                    fill="#fff"
                />
                <path d="M107 698.5l-7 4.5v-9z" fill="#8f99dc" />
            </g>
        </svg>
    );
};

export default PlayVoice;
